import css from '@styled-system/css'
import styleToCss from './styleToCss'

export default (styled, theme) => styleToCss(css(styled)(theme))
